







































































import {redirectTime} from '@/constants/constants';
import validationMsgs from '@/constants/validation';
import Role from '@/models/role';
import {API} from '@/services/api/api';
import {assignRole, getAssignedRoleByUserId, getRoleList} from '@/services/api/roles';
import validator from '@/utils/validator';
import {Vue, Component, Provide} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  computed: {...mapGetters(['roleList'])},
})
export default class EditAssignedRole extends Vue {
  userId = -1;
  roleId = -1;

  showSuccessToast: any;
  showErrorToast: any;
  isLoading = true;
  saving = false;

  //data variables
  roles: Role[] = [];
  user: any = {};
  userName = '';

  //validation variables
  roleValidationMsg = null;

  mounted() {
    this.userId = parseInt(this.$route.params.id);
    this.setupView();
  }
  //view setup
  async setupView() {
    try {
      const rolesReq = getRoleList();
      const userReq = API.getUserById(this.userId);

      const response = await Promise.all([rolesReq, userReq]);

      const rolesListResponse: Role[] = response[0].data; //roles list
      this.roles = rolesListResponse.filter((role) => role.active === true);

      const userResponse = response[1]; //user list
      if (userResponse.data) {
        this.user = userResponse.data;
        this.userName = this.user.email;
        const groups = this.user.internal;
        this.roleId = groups.length ? groups[0].groupId : -1;
      } else {
        this.showErrorToast({msg: userResponse.error});
      }
    } catch (e) {
      //
    } finally {
      this.isLoading = false;
    }
  }

  //validation functions
  validateRoleId() {
    const id = this.roleId;
    if (id === -1) {
      this.roleValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.roleValidationMsg = null;
      return true;
    }
  }
  validateAll() {
    return this.validateRoleId();
  }
  async onSubmitClick() {
    if (!this.validateAll()) {
      return;
    }
    this.saving = true;
    const assignedRole = {
      GroupId: this.roleId,
      Users: [{UserId: this.user.internalId}],
    };
    try {
      let response: any = await assignRole(assignedRole);
      if (response.data) {
        let message: string = response.message;
        if (message.includes('Successfully')) message = 'Record updated successfully.';
        this.showSuccessToast({msg: message});
        setTimeout(() => this.$router.go(-1), redirectTime);
      } else {
        let errorMsg = response.error;
        this.showErrorToast({msg: errorMsg});
      }
    } catch (e) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.saving = true;
    }
  }
}
